export default __webpack_public_path__ + "static/media/arrow-grey-right.a3572a64.svg";